<template>
  <div class="flex w-full flex-col gap-2">
    <h3 class="text-lg font-semibold">Posições</h3>
    <div class="overflow-y-auto rounded-lg">
      <table class="w-full text-sm">
        <!-- HEADER -->
        <ontick-table-head-component :headers="headers" @sort="sort" />

        <!-- BODY -->
        <tbody>
          <template v-for="item in positions">
            <template v-if="['PORTFOLIO', 'MULTISYMBOL'].includes(item.type)">
              <tr
                class="text-xs"
                :class="
                  expandedPortfolios.includes(item.investment_id)
                    ? 'dark:bg-ontick-graphite-600 bg-ontick-steel-200'
                    : 'dark:bg-ontick-graphite-500 bg-ontick-steel-100'
                "
                :key="item.investment_id"
              >
                <td class="td">
                  <div>
                    <button
                      class="transition-all ease-in-out"
                      :class="{
                        '-rotate-90 transform': !expandedPortfolios.includes(item.investment_id),
                      }"
                      @click="expandPortfolio(item.investment_id)"
                    >
                      <i v-html="$icons.expand"></i>
                    </button>
                    <span>
                      {{ item.strategy_name }}
                    </span>
                  </div>
                </td>
                <td class="td">
                  <span v-if="item.type === 'PORTFOLIO'"> Portfólio </span>
                  <span v-else-if="item.type === 'MULTISYMBOL'"> Multiativo </span>
                </td>
                <td class="td"></td>
                <td class="td"></td>
                <td class="td"></td>
                <td class="td"></td>
                <td class="td"></td>
                <td class="td">
                  <div>
                    <i
                      v-html="$icons.error"
                      v-if="connectionStatus.error"
                      content="Erro na conexão. Atualize a página para tentar novamente."
                      v-tippy="{ arrow: true, theme: 'red' }"
                    ></i>
                    <template v-else>
                      <i
                        v-html="$icons.loading"
                        v-if="connectionStatus.awaitingConnection || portfolioPnl(item) === null"
                        class="text-ontick-blue-600"
                        :content="spinnerTooltip(connectionStatus.awaitingConnection, portfolioPnl(item) === null)"
                        v-tippy="{ arrow: true, theme: 'green' }"
                      ></i>
                      <i
                        v-else-if="portfolioPnl(item) != 0"
                        :class="
                          portfolioPnl(item) > 0
                            ? 'text-ontick-green-700 dark:text-ontick-green-500 rotate-0'
                            : 'text-ontick-red-500 rotate-180'
                        "
                        v-html="$icons.arrow_drop"
                      ></i>
                      <span
                        class="dark:text-gray-300"
                        v-if="!(connectionStatus.awaitingConnection || portfolioPnl(item) === null)"
                      >
                        {{ portfolioPnl(item) | currency }}
                      </span>
                    </template>
                  </div>
                </td>
                <td class="td"></td>
              </tr>
              <template v-if="expandedPortfolios.includes(item.investment_id)">
                <position-row-component
                  v-for="position in item.curr_positions"
                  :key="position.investment_id"
                  :data="position"
                  type="portfolio-component"
                  :connectionStatus="connectionStatus"
                />
              </template>
            </template>
            <position-row-component
              :key="item.investment_id"
              :data="item"
              type="strategy"
              :connectionStatus="connectionStatus"
              v-else
            />
          </template>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import OntickTableHeadComponent from "../../../../shared/components/basic/ontick-table-head.component.vue";
import newPositionTableMixin from "./new-position-table.mixin";
import PositionRowComponent from "./position-row.component.vue";

export default {
  mixins: [newPositionTableMixin],

  props: {
    positions: {
      type: Array,
    },
    connectionStatus: {
      type: Object,
    },
  },

  components: {
    // OntickSymbolPillComponent,
    // OntickPositionPillComponent,
    PositionRowComponent,
    OntickTableHeadComponent,
  },

  data() {
    return {
      expandedPortfolios: [],
      sortDirection: "",
      sortKey: "",
      treatedData: [],
    };
  },

  computed: {
    sortedData() {
      switch (this.sortDirection) {
        case "asc":
          return this.positions.sort((a, b) => {
            if (a[this.sortKey] < b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] > b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        case "desc":
          return this.positions.sort((a, b) => {
            if (a[this.sortKey] > b[this.sortKey]) {
              return -1;
            } else if (a[this.sortKey] < b[this.sortKey]) {
              return 1;
            } else {
              return 0;
            }
          });
        default:
          return this.positions;
      }
    },
  },

  methods: {
    spinnerTooltip(awaitingConnection, awaitingData) {
      if (awaitingConnection) {
        return "Aguardando conexão...";
      } else if (awaitingData) {
        return "Aguardando dados atualizados...";
      }
    },
    sort({ sortDirection, sortKey }) {
      this.sortDirection = sortDirection;
      this.sortKey = sortKey;
    },
    expandPortfolio(investment_id) {
      if (this.expandedPortfolios.includes(investment_id)) {
        this.expandedPortfolios.splice(
          this.expandedPortfolios.findIndex((item) => item.investment_id === investment_id),
          1
        );
      } else {
        this.expandedPortfolios.push(investment_id);
      }
    },

    portfolioPnl(investment) {
      return investment.curr_positions.reduce((acc, curr) => {
        return acc + (curr.open_pnl || 0);
      }, 0);
    },
  },
};
</script>

<style lang="scss" scoped>
th {
  @apply text-left;
}
td {
  @apply gap-1 py-2 px-4 text-gray-600 dark:text-gray-400;
  & > div {
    @apply flex items-center gap-1;
  }
}
</style>
